import { useCallback, useEffect, useRef, useState } from 'react';
import { haccpApi } from '../../haccpApi';

// Stato firme: mentre l'app controlla i documenti si aggiorna da solo ogni 4 secondi
export const useFirme = (attivo) => {
  const [dati, setDati] = useState(null);
  const timer = useRef(null);
  const ricarica = useCallback(async () => {
    clearTimeout(timer.current);
    try {
      const r = await haccpApi.get('/documenti/firme');
      setDati(r);
      if (r.verifica.in_corso) timer.current = setTimeout(ricarica, 4000);
    } catch { setDati((d) => d || { errore: true }); }
  }, []);
  useEffect(() => { if (attivo) ricarica(); return () => clearTimeout(timer.current); }, [attivo, ricarica]);
  return { dati, ricarica };
};

export const mancantiDoc = (doc) => (doc?.firme?.spazi || []).filter((s) => !s.firmata && !s.ignorata).length;

// Firmato: ha spazi per firme e sono tutti firmati (nell'app, già sulla carta o segnati "firmato a mano")
export const firmatoDoc = (doc) => (doc?.firme?.spazi || []).length > 0 && !mancantiDoc(doc);
export const firmatari = (doc) => [...new Map((doc?.firme?.spazi || []).filter((s) => s.applicata)
  .map((s) => [s.applicata.firmatario, s.applicata])).values()];

// Firma aggiunta a mano dove l'app non ha trovato uno spazio: parte in basso a destra, si sposta toccando la pagina
export const nuovaFirma = (doc, nome) => ({
  doc: { id: doc.id, nome, tipo: doc.tipo, spazi: doc.spazi || doc.firme?.spazi || [], pagine_totali: doc.pagine_totali || doc.firme?.pagine_totali || null,
    chiede_data: doc.chiede_data ?? (doc.tipo === 'consegna_dpi' && !doc.dpi?.data_consegna) },
  spazio: { id: 'nuovo', pagina: 1, ruolo: 'Firma aggiunta', nome: null, manuale: true, firmata: false, box: [820, 640, 880, 900] },
});
